import { FC, useEffect, useState } from 'react';

import { Box } from '@mui/material';
import clsx from 'clsx';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSection, getActiveSubSection } from 'store/useBusinessToolStore/selectors';

import { useBusinessToolAiContext } from 'pages/BusinessToolPage/components/BusinessToolAiProvider';

import { Block, useScrollManager } from 'hooks/useScrollManager';

import { UpButton } from 'components/_basic/UpButton';

import { IBusinessPageToolLayoutProps } from './types';

import styles from './BusinessToolPageDesktopLayout.module.scss';

export const DesktopLayout: FC<IBusinessPageToolLayoutProps> = ({
  isPreviewMode,
  header,
  modeSwitch,
  typeSwitch,
  sectionsNavigation,
  form,
  aside,
}) => {
  const {
    blockMiddleRef,
    blockRightRef,
    handleScroll,
    scrollToTop,
    middleBlockScrollToTop,
    isButtonVisible,
  } = useScrollManager(isPreviewMode);
  const { loadingStates, isWholeDocumentLoading } = useBusinessToolAiContext();
  const [isAiModalVisible, setIsAiModalVisible] = useState(false);

  const { activeSubSection, activeSection } = useBusinessToolStore((state) => ({
    activeSubSection: getActiveSubSection(state),
    activeSection: getActiveSection(state),
  }));
  const isSectionLoading = loadingStates[activeSection];

  useEffect(() => {
    middleBlockScrollToTop();
  }, [activeSection, activeSubSection]);

  useEffect(() => {
    if (isSectionLoading && isWholeDocumentLoading) {
      setIsAiModalVisible(true);
      return;
    }
    setIsAiModalVisible(false);
  }, [loadingStates, isWholeDocumentLoading]);

  return (
    <div className={styles['root']}>
      <div className={styles['header']}>{header}</div>
      <div className={styles['content']}>
        <Box className={styles['leftSidebar']}>
          <div className={styles['mode_switch']}>{modeSwitch}</div>
          {typeSwitch}
          {sectionsNavigation}
        </Box>
        <Box
          ref={blockMiddleRef}
          onScroll={() => handleScroll(Block.BlockMiddle)}
          className={clsx(styles['form'], isAiModalVisible && styles['form_ai'])}
        >
          {form}
        </Box>
        <Box ref={blockRightRef} onScroll={() => handleScroll(Block.BlockRight)} className={styles['rightSidebar']}>
          {aside}
        </Box>
        {isButtonVisible && <UpButton onClick={scrollToTop} />}
      </div>
    </div>
  );
};
